export default {
  computed: {
    /**
     * true, если открыли основной сайт.
     * При добавлении новых свойств, нужно обновить isGeneralSite
     */
    isGeneralSite() {
      const {
        isNiko, isMed, isSoop, isSod,
      } = this
      return [isNiko, isMed, isSod, isSoop].every((el) => !el)
    },

    isNiko() {
      return window.location.host.includes('niko')
    },
    isMed() {
      return window.location.host.includes('lk-medk')
    },
    isSoop() {
      return (window.location.host.includes('lk-soop') || process.env.VUE_APP_IS_SOOP === 'true')
    },
    isSod() {
      return window.location.host.includes('lk-sod')
    },
  },
}
